import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useHistory } from 'react-router-dom';
import type { To, Location } from 'history';

export type NavigateOptions = { replace?: boolean; state?: Location['state'] };

const buildToPath = (path: string | undefined, basename: string | undefined = '/') =>
  path ? `${basename}${path}`.replace(/\/\//, '/') : undefined;

export const useNavigate = () => {
  const { push, replace, go } = useHistory();

  return useCallback(
    (param: number | To, options: NavigateOptions = {}) => {
      if (typeof param === 'number') {
        return go(param);
      }

      const navigateFn = options.replace ? replace : push;

      if (typeof param === 'string') {
        const path = buildToPath(param);

        if (!path) {
          return;
        }

        return navigateFn(path);
      }

      return navigateFn({
        ...param,
        pathname: buildToPath(param.pathname),
      });
    },
    [push, replace, go],
  );
};
